import { useQuery } from "@tanstack/react-query";
import { fetchPortalAuthConfig } from "../../api/clientPortal";
import { FirmMark } from "./FirmMark";

/** The client doors' head: the firm's logo and name; the site's lockup until the firm sets them. */
export function PortalAuthBrand() {
  // The sign-in page's own key and answer, so a door and its head agree.
  const { data } = useQuery({
    queryKey: ["portal", "auth-config"],
    queryFn: fetchPortalAuthConfig,
    staleTime: Infinity,
  });
  // Blank until the answer: a name that changes under a client's eyes is
  // worse than a moment of nothing.
  return (
    <div className="portal-auth-mark">
      {data && (
        <>
          <FirmMark firmName={data.firmName} logoVersion={data.logoVersion} size={32} />
          {data.firmName ?? "DuraLex"}
        </>
      )}
    </div>
  );
}
